// src/lib/queryKeys.ts
export const qk = {
  me: () => ["me"] as const,
  clientBranding: (clientId?: string | null) =>
    ["client-branding", clientId] as const,
  clientUsers: (clientId?: string | null) =>
    ["client-users", clientId] as const,
  clientUserCount: (clientId?: string | null) =>
    ["client-user-count", clientId] as const,
  clientJobRoles: (clientId?: string | null) =>
    ["client-job-roles", clientId] as const,
  clients: () => ["clients"] as const,
  clientDetails: (clientId?: string | null) =>
    ["client-details", clientId] as const,
  centralUsers: (clientId?: string | null) =>
    ["central-users", clientId] as const,
  centralDepartments: (clientId?: string | null) =>
    ["central-departments", clientId] as const,
  centralJobRoles: (clientId?: string | null) =>
    ["central-job-roles", clientId] as const,
  defaultDepartments: () => ["default-departments"] as const,
  defaultJobRoles: () => ["default-job-roles"] as const,
  dashboardSettings: (clientId?: string | null) =>
    ["dashboard-settings", clientId] as const,
  emailTemplate: (templateKey: string) =>
    ["email-template", templateKey] as const,
  metrics: {
    stats: (params?: unknown) => ["metrics", "stats", params] as const,
    trends: (params?: unknown) => ["metrics", "trends", params] as const,
    distribution: (metric: string, params?: unknown) =>
      ["metrics", "distribution", metric, params] as const,
    patterns: (metric: string, params?: unknown) =>
      ["metrics", "patterns", metric, params] as const,
    comparison: (params?: unknown) =>
      ["metrics", "comparison", params] as const,
    overallRange: (clientId?: string | null) =>
      ["metrics", "overall-range", clientId] as const,
  },
  programmeProfile: {
    stats: (params?: unknown) =>
      ["programme-profile", "stats", params] as const,
    ageDistribution: (params?: unknown) =>
      ["programme-profile", "age-distribution", params] as const,
    workingEnvironment: (params?: unknown) =>
      ["programme-profile", "working-environment", params] as const,
    demographics: (params?: unknown) =>
      ["programme-profile", "demographics", params] as const,
    travelTime: (params?: unknown) =>
      ["programme-profile", "travel-time", params] as const,
    programmeGoals: (params?: unknown) =>
      ["programme-profile", "programme-goals", params] as const,
    workingHourPatterns: (params?: unknown) =>
      ["programme-profile", "working-hour-patterns", params] as const,
    lifestyleHabits: (params?: unknown) =>
      ["programme-profile", "lifestyle-habits", params] as const,
    activeUsersByRole: (params?: unknown) =>
      ["programme-profile", "active-users-by-role", params] as const,
  },
  jeopardy: {
    atRiskUsers: (params?: unknown) =>
      ["jeopardy", "at-risk-users", params] as const,
    cardiovascular: (params?: unknown) =>
      ["jeopardy", "cardiovascular", params] as const,
  },
  wellbeingFacts: () => ["wellbeing", "facts"] as const,
  wellbeingCarousel: () => ["wellbeing", "carousel"] as const,
  preRegistrations: (clientId?: string | null, status?: string) =>
    ["pre-registrations", clientId, status ?? "pending"] as const,
  participants: (params?: unknown) => ["participants", params] as const,
  participantDetail: (participantId?: string | null) =>
    ["participants", "detail", participantId] as const,
  participantInteractions: (participantId?: string | null) =>
    ["participants", "interactions", participantId] as const,
  participantDocuments: (participantId?: string | null) =>
    ["participants", "documents", participantId] as const,
  participantTasks: (participantId?: string | null) =>
    ["participants", "tasks", participantId] as const,
  devices: () => ["participants", "devices"] as const,
  taskTemplates: () => ["participants", "task-templates"] as const,
  participantUsers: (clientId?: string | null) =>
    ["participants", "users", clientId] as const,
  participantWearJeopardy: (params?: unknown) =>
    ["participants", "wear-jeopardy", params] as const,
  participantWearJeopardyNotes: (participantId?: string | null) =>
    ["participants", "wear-jeopardy", "notes", participantId] as const,
  participantSignupAnswersBulk: (clientId?: string | null) =>
    ["participants", "signup-answers-bulk", clientId] as const,
  adminQuestions: (clientId?: string | null, type?: string) =>
    ["admin-questions", clientId, type ?? "all"] as const,
};
